module.exports = __webpack_public_path__ + "files/2fd678253c92cb6106e0e950d7755b46.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-bold-webfont.woff
// module id = 744
// module chunks = 60